import { trpc } from '@/shared/api/trpc';

export const useTaskById = (id: string | undefined) =>
  trpc.tasks.byId.useQuery({ id: id ?? '' }, { enabled: Boolean(id) });
